import { useState, useEffect, useContext } from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { businessManagerService } from 'src/services';

function EvaluationCriteria(props) {
    const { t, i18n } = useTranslation();
    const idBusinessManager = props.idBusinessManager;
    const idLang = i18n.language === 'fr' ? 1 : 2;
    const [skillBusinessManager, setSkillBusinessManager] = useState([{
        id: 0,
        name: ''
    }]);

    useEffect(() => {
        businessManagerService.getSkillBusinessManager(idBusinessManager, idLang).then(response => {
            if (response.data.success) {
                setSkillBusinessManager(response.data.data)
            }
        }).catch(err => {

        });
    }, [idBusinessManager]);
    return (
        <div style={{ marginTop: 15 }} >
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {skillBusinessManager.map((row) => (
                            <TableRow key={row.id} style={{ height: 40 }}>
                                <TableCell component="th" scope="row" style={{ paddingLeft: 10 }}><b>{row.name}</b></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div></div>
        </div>
    );
}

export default EvaluationCriteria;